import utils from '@/mixins/utils.js'
import { getQuantidadeAgendados } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirEspontaneos Indica se o filtro de espontâneos está ativo.
 * @param {Boolean} exibirAgendados Indica se o filtro de agendados está ativo.
 * @param {Object|null} equipe Equipe selecionada.
 * @returns {Object}
 */
export function getDataFields(
  mes = null,
  exibirEspontaneos = false,
  exibirAgendados = false,
  equipe = null
) {
  const colunaQuantidade = exibirEspontaneos
    ? 'Espontâneos'
    : exibirAgendados
    ? 'Agendados'
    : 'Atendimentos'

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeAgendados(
          item,
          mes,
          exibirEspontaneos,
          exibirAgendados,
          equipe
        )
      },
    },
  }
}

export const infoHtml = ``
